// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"874":"8fc695c9","2498":"ea4353e4","9628":"ffe73276"}[chunkId] + ".chunk.css";
};